export default "__VITE_ASSET__D4rC7iFR__"